import GeneralFilter from '../../../../Model/GeneralFilter'

export default class FAQFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
